import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MutualModule } from '@shared/mutual/mutual.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';

import { ContainerDocumentsComponent, ViewVoyageComponent, VoyageEditComponent, VoyageListComponent } from './components';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DocumentModule } from '@shared/document/document.module';
import { VoyageTotalsComponent } from '@app/modules/management/voyages-management/components';
import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { AddressModule } from '@shared/address/address.module';

@NgModule({
  declarations: [VoyageEditComponent, VoyageListComponent, ViewVoyageComponent, ContainerDocumentsComponent, VoyageTotalsComponent],
  imports: [
    CommonModule,
    MutualModule,
    FormWrapperModule,
    NgxPaginationModule,
    RouterModule,
    PipesSharedModule,
    BsDropdownModule.forRoot(),

    DocumentModule,
    CustomModalModule,
    AddressModule,
  ],
  exports: [VoyageEditComponent, VoyageListComponent, ViewVoyageComponent, ContainerDocumentsComponent, VoyageTotalsComponent],
})
export class VoyagesModule {}
